import { render, staticRenderFns } from "./Agb.vue?vue&type=template&id=68451718&scoped=true&"
import script from "./Agb.vue?vue&type=script&lang=js&"
export * from "./Agb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68451718",
  null
  
)

export default component.exports